import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import defaultimage from "../assets/default-image.png";



const PersonalHome = () => {
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loginType, setLoginType] = useState("User"); // State to store login type
  const [selectedScopes, setSelectedScopes] = useState([]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const encodedData = urlParams.get('data');
    if (encodedData) {
      try {
        const decoded = JSON.parse(atob(decodeURIComponent(encodedData)));
        console.log("Decoded user info:", decoded);
  
        setUserProfile(decoded); // Save it in state
        setLoading(false);
      } catch (err) {
        console.error("Failed to decode data", err);
        setLoading(false);
      }
    }
  }, []);
  // Handle LinkedIn login
  const handleLinkedInLogin = () => {
    if (!loginType) {
      Swal.fire({
        icon: 'warning',
        title: 'Account Type Required',
        text: 'Please select an account type before login with LinkedIn'
      });
      return;
    }

    

    console.log(loginType);
    const linkedinAuthorizeUrl = `${process.env.REACT_APP_API_BASE_URL}/api/linkedin/authorize?UserID=${userProfile.UserID}&loginType=${loginType}&scopes=${selectedScopes.join(' ')}&clientId=${userProfile.clientId}`;
    window.location.href = linkedinAuthorizeUrl;
  };



 

  return (
    <>
     
   
          {loading ? <div className='spinner'></div> :
             <div className="card shadow-sm p-3" style={{ border: 'none', backgroundColor: '#fff' }}>
               <div className="card-header d-flex justify-content-between align-items-center" style={{ border: 'none', backgroundColor: '#fff' }}>
                 <h5 style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}>Welcome to KnackVibes</h5>
               
               </div>
               <hr />
               <div className='text-center'>
                 <div className='d-flex justify-content-center align-items-center text-center'>
                   {/* <div className='mb-3'>
                     <label htmlFor="loginTypeSelect" style={{ marginRight: '10px', marginTop: 15 }}>Select Linkedin Login Type:</label>
                   </div> */}
                   <div>
                     <select
                       id="loginTypeSelect"
                       value={loginType}
                       style={{ display: 'none' }} // Hide the dropdown
                       onChange={(e) => { setLoginType(e.target.value); localStorage.setItem("AccountType", e.target.value); }}
                       
                     >
                       {/* <option value="">Select Type</option> */}
                       <option value="User">User</option>
                     
                     </select>
                   </div>
                 </div>
                 <div>
                   <button
                     style={{ backgroundColor: '#fff', color: '#2e3192', borderRadius: 8 }}
                     className="bg-white-500 text-black p-3 shadow-sm"
                     onClick={handleLinkedInLogin}
                   >
                     <i className="fa fa-linkedin mr-5" style={{ color: '#2e3192', marginRight: '20px' }}></i>
                     <b>Login with LinkedIn</b>
                   </button>
                 </div>
              
                 
               </div>

      
             </div>
             
           }
         
         </>

) 
 
};

export default PersonalHome;
